var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkAnywhere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 219,
    viewBox: "0 0 220 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.096 219C170.571 219 219.596 169.975 219.596 109.5C219.596 49.0248 170.571 0 110.096 0C49.6208 0 0.595947 49.0248 0.595947 109.5C0.595947 169.975 49.6208 219 110.096 219Z",
    fill: "#FE8083"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.77 73.5639H88.423V47.2149C88.4044 44.5945 88.9044 41.9964 89.8943 39.5701C90.8842 37.1438 92.3444 34.9374 94.1908 33.0779C96.0371 31.2184 98.2331 29.7426 100.652 28.7355C103.072 27.7284 105.666 27.21 108.286 27.21C110.907 27.21 113.501 27.7284 115.921 28.7355C118.34 29.7426 120.536 31.2184 122.382 33.0779C124.229 34.9374 125.689 37.1438 126.679 39.5701C127.669 41.9964 128.169 44.5945 128.15 47.2149V73.5639H114.784",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.712 87.2889H83.861V117.298H132.712V87.2889Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.286 107.152C110.969 107.152 113.145 104.976 113.145 102.293C113.145 99.6093 110.969 97.4338 108.286 97.4338C105.602 97.4338 103.427 99.6093 103.427 102.293C103.427 104.976 105.602 107.152 108.286 107.152Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8439 155.854C93.8053 155.583 91.9576 154.514 90.7071 152.882C89.4567 151.249 88.9059 149.187 89.1759 147.148L92.6759 124.148C92.8097 123.138 93.1411 122.165 93.651 121.284C94.1609 120.402 94.8395 119.63 95.6479 119.011C96.4563 118.392 97.3788 117.938 98.3627 117.675C99.3465 117.412 100.372 117.346 101.382 117.48V117.48C102.391 117.614 103.365 117.945 104.246 118.455C105.128 118.965 105.9 119.643 106.519 120.452C107.138 121.26 107.592 122.183 107.855 123.167C108.118 124.15 108.184 125.176 108.05 126.186L104.55 149.186C104.279 151.224 103.21 153.072 101.578 154.323C99.9451 155.573 97.8826 156.124 95.8439 155.854V155.854Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.286 155.942C119.272 156.038 118.249 155.934 117.276 155.635C116.303 155.336 115.397 154.848 114.613 154.2C113.828 153.551 113.178 152.754 112.701 151.854C112.224 150.955 111.929 149.97 111.833 148.956L109.31 125.845C109.214 124.831 109.318 123.808 109.617 122.835C109.916 121.862 110.404 120.957 111.053 120.172C111.702 119.387 112.499 118.738 113.399 118.261C114.298 117.784 115.283 117.489 116.297 117.393V117.393C117.311 117.297 118.333 117.401 119.307 117.7C120.28 117.999 121.185 118.486 121.97 119.135C122.755 119.784 123.405 120.581 123.882 121.481C124.359 122.38 124.654 123.365 124.75 124.379L127.272 147.49C127.466 149.537 126.839 151.578 125.529 153.163C124.219 154.748 122.333 155.747 120.286 155.942V155.942Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.539 155.826C98.7771 155.826 100.924 156.715 102.506 158.298C104.089 159.88 104.978 162.027 104.978 164.265V164.365H88.1V164.265C88.1 162.027 88.9891 159.88 90.5717 158.298C92.1543 156.715 94.3008 155.826 96.539 155.826V155.826Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.711 155.826C121.949 155.826 124.096 156.715 125.678 158.298C127.261 159.88 128.15 162.027 128.15 164.265V164.365H111.272V164.265C111.272 162.027 112.161 159.88 113.744 158.298C115.326 156.715 117.473 155.826 119.711 155.826V155.826Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.77 76.5109H99.886C98.4705 76.5109 97.0689 76.7897 95.7612 77.3314C94.4535 77.8731 93.2652 78.6671 92.2644 79.668C91.2636 80.6689 90.4697 81.8572 89.9281 83.165C89.3865 84.4727 89.1078 85.8744 89.108 87.2899H128.15C128.15 85.8744 127.871 84.4727 127.33 83.165C126.788 81.8572 125.994 80.6689 124.993 79.668C123.993 78.6671 122.804 77.8731 121.497 77.3314C120.189 76.7897 118.787 76.5109 117.372 76.5109H114.781",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.781 68.6979V76.3979C114.781 77.1209 114.639 77.8368 114.362 78.5048C114.085 79.1727 113.68 79.7797 113.168 80.2909C112.657 80.8021 112.05 81.2075 111.382 81.4841C110.714 81.7607 109.998 81.903 109.275 81.9029V81.9029C107.815 81.9029 106.415 81.3229 105.382 80.2905C104.35 79.2581 103.77 77.8579 103.77 76.3979V68.6979",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5389 50.206V56.545C96.5389 58.2176 96.8684 59.8739 97.5086 61.4193C98.1488 62.9646 99.0871 64.3687 100.27 65.5514C101.453 66.734 102.857 67.6721 104.402 68.312C105.948 68.952 107.604 69.2812 109.277 69.2809C110.95 69.2811 112.606 68.9518 114.151 68.3118C115.696 67.6718 117.101 66.7337 118.283 65.551C119.466 64.3684 120.404 62.9643 121.044 61.419C121.684 59.8738 122.014 58.2176 122.014 56.545V48.81C122.014 48.81 115.035 45.0349 115.268 39.3619C115.265 39.3619 110.613 50.671 96.5389 50.206Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.176 150.716H31.7V100.216C31.7 97.1616 32.9133 94.2325 35.0729 92.0728C37.2326 89.9131 40.1617 88.6998 43.216 88.6998C44.7283 88.7001 46.2257 88.9982 47.6228 89.5772C49.0199 90.1562 50.2892 91.0047 51.3584 92.0742C52.4276 93.1438 53.2756 94.4134 53.8541 95.8107C54.4326 97.208 54.7302 98.7055 54.7299 100.218V123.118H91.983",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.226 123.114H165.46V100.214C165.46 97.1596 166.673 94.2305 168.833 92.0708C170.993 89.9112 173.922 88.6979 176.976 88.6979V88.6979C180.03 88.6979 182.959 89.9112 185.119 92.0708C187.279 94.2305 188.492 97.1596 188.492 100.214V150.714H127.272",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1 54.3209H77.6C68.4819 54.3212 59.7374 57.9435 53.2899 64.3909C46.8425 70.8383 43.2202 79.5829 43.22 88.7009",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.014 88.7009C177.014 79.5828 173.392 70.8381 166.944 64.3906C160.497 57.9431 151.752 54.3209 142.634 54.3209H129.248",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.978 150.715H111.673",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.398 150.723H54.769V164.373H60.398V150.723Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.402 150.723H159.773V164.373H165.402V150.723Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkAnywhere);
export default __webpack_public_path__ + "static/media/Work Anywhere.feeb1cab829b3014961310fe1db59d3d.svg";
export { ForwardRef as ReactComponent };